// @flow
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import styles from './clientCommunication.scss';
import { setPageName } from '../../../services/pageService/pageActionCreator';

import InputField from '../../commons/formElements/inputField/inputField';
import SearchClient from '../../commons/searchClient/searchClient';
import Select from '../../commons/formElements/select/select';
import SummaryAlertSettings from '../../commons/summaryAlertSettings/summaryAlertSettings';
import RealTimeAlertsSettings from '../../commons/realTimeAlertsSettings/realTimeAlertsSettings';
import {
  getUserClients,
  getDefaultUserSettings,
  filterClientList,
  getUserOptionList,
  editUser,
  addUser
} from './clientCommunicationRedux/clientCommunicationActionCreator';
import {
  regionType,
  userTypes,
  clusterType,
  validateUserCallData,
  getUserTypeList
} from './clientCommunicationHelper';
import Loader from '../../commons/loader/loader';

type Props = {
  setPageName: Function,
  userProfile: Object,
  getUserClients: Function,
  clientCommunicationState: Object,
  getDefaultUserSettings: Function,
  filterClientList: Function,
  getUserOptionList: Function,
  editUser: Function,
  addUser: Function
};

type State = {
  screenName: string,
  userTypes: Array<any>,
  regionType: Array<any>,
  clusterType: Array<any>,
  selectedClient: Object,
  pageData: Object
  // showSettingType: string
};

const pageObj = {
  pageName: 'Manage Alerts'
};

class ClientCommunication extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      userTypes,
      regionType,
      clusterType,
      screenName: ''
      // showSettingType: ""
    };
    this.userSearchTimeout = null;
    this.clientSearchTimeout = null;
    this.loggedInUserTypeForClient = '';
    this.clientDisplayAccessorList = ['displayName', 'clientCode'];
    this.userDisplayAccessorList = ['name', 'email', 'mobileNumber'];
    this.userCreateRoleForClient = false;
  }

  componentWillMount() {
    this.props.setPageName(pageObj);
  }

  componentDidMount() {
    this.props.getUserClients(this.props.userProfile);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.clientCommunicationState.ccPageData !==
      this.props.clientCommunicationState.ccPageData
    ) {
      this.setPageData(nextProps);
    } else if (
      nextProps.clientCommunicationState.defaultUserSettings !==
      this.props.clientCommunicationState.defaultUserSettings
    ) {
      this.setPageDataForNewUser(nextProps);
    }
    if (
      nextProps.clientCommunicationState.fetchedInitialPageDetails &&
      nextProps.clientCommunicationState.errorMessage
    ) {
      toastr.error('Error', nextProps.clientCommunicationState.errorMessage);
    }
    if (
      nextProps.clientCommunicationState.postCallCompleted &&
      nextProps.clientCommunicationState.errorMessage
    ) {
      toastr.error('Error', nextProps.clientCommunicationState.errorMessage);
    }
    if (
      nextProps.clientCommunicationState.postCallCompleted &&
      nextProps.clientCommunicationState.message
    ) {
      toastr.success('Success', nextProps.clientCommunicationState.message);
    }
  }

  onUserTypeSelect(val, obj) {
    // eslint-disable-next-line no-console
    console.log('set user type state= ', val, obj);
    const pageData = Object.assign({}, this.state.pageData, {
      userType: obj.val
    });

    if (this.state.screenName === 'addUser' && val) {
      if (val === 'CONSIGNEE' || val === 'CONSIGNER' || val === 'FIELD_USER') {
        pageData.isRealTimeAlert = true;
        pageData.isSummaryAlert = false;
      } else if (val !== 'SAM' && val !== 'SAM_LEAD') {
        pageData.isRealTimeAlert = false;
        pageData.isSummaryAlert = true;
      } else {
        pageData.isRealTimeAlert = null;
        pageData.isSummaryAlert = null;
      }
    }
    this.setState({
      pageData
    });
  }

  onRegionTypeSelect(val) {
    // eslint-disable-next-line no-console
    console.log('set RegionType state= ', val);
  }

  onClusterTypeSelect(val) {
    // eslint-disable-next-line no-console
    console.log('set cluster type state= ', val);
  }

  onClientInputChange(val) {
    if (!val) {
      return;
    }
    // eslint-disable-next-line no-console
    console.log('on client search val = ', val);
    // Filtering client list basis of val string. Debouncing 1 sec -- have to move debounce method in helpers
    if (this.clientSearchTimeout !== null) {
      clearTimeout(this.clientSearchTimeout);
    }
    this.clientSearchTimeout = setTimeout(
      this.props.filterClientList.bind(this, val),
      1000
    ); // Perform search after 1 second
  }

  onClientSelect(val) {
    // eslint-disable-next-line no-console
    console.log('on client select val = ', val);
    if (this.state.screenName !== 'addUser') {
      this.setState({
        selectedClient: val,
        pageData: val
      });
    } else {
      this.setState({
        selectedClient: val
      });
    }
    this.loggedInUserTypeForClient = val.userType;
    this.userCreateRoleForClient = val.ccCreateRole;
  }

  onUserInputChange(val) {
    if (!val) {
      return;
    }
    if (!this.state.selectedClient || !this.state.selectedClient.clientId) {
      toastr.error('Error', 'No client associated with this user');
      return;
    }
    // Make an API call with user search string and client ID. And re-render the user options list
    const requestObj = {
      name: val,
      clientId: this.state.selectedClient && this.state.selectedClient.clientId,
      userType: this.loggedInUserTypeForClient
    };
    if (this.userSearchTimeout !== null) {
      clearTimeout(this.userSearchTimeout);
    }
    this.userSearchTimeout = setTimeout(
      this.props.getUserOptionList.bind(this, requestObj),
      1000
    );
  }

  onUserSelect(val) {
    // eslint-disable-next-line no-console
    console.log('on user select val = ', val);
    this.setState({
      selectedUser: val,
      pageData: val,
      userTypes: getUserTypeList(val.allowedUserTypes)
    });
  }

  setPageData(nextProps) {
    let clientSearchOptions =
      nextProps.clientCommunicationState &&
      nextProps.clientCommunicationState.ccPageData;
    if (
      (!clientSearchOptions || !clientSearchOptions.length) &&
      nextProps.clientCommunicationState.ccPageData
    ) {
      clientSearchOptions = nextProps.clientCommunicationState.ccPageData; // Set client search options if the list does not exists i.e. first time load
    }
    if (clientSearchOptions && clientSearchOptions.length) {
      if (!this.state.selectedClient) {
        // Select the first element of list as default client
        const firstObj = clientSearchOptions[0];
        let { selectedClient, pageData } = this.state;
        if (!selectedClient) {
          selectedClient = firstObj;
        }

        if (!pageData) {
          pageData = firstObj;
        }

        this.setState({
          selectedClient,
          pageData
        });
        this.loggedInUserTypeForClient = pageData.userType; // Set loggedIn user type from landing API call
        this.userCreateRoleForClient = pageData.ccCreateRole;
      }
    }
  }

  setPageDataForNewUser(nextProps) {
    if (
      this.state.screenName === 'addUser' &&
      nextProps.clientCommunicationState.defaultUserSettings &&
      nextProps.clientCommunicationState.defaultUserSettings.data
    ) {
      const pageDataUpdated = Object.assign({}, this.state.pageData, {
        realTimeAlerts:
          nextProps.clientCommunicationState.defaultUserSettings.data
            .realTimeAlerts,
        summaryAlerts:
          nextProps.clientCommunicationState.defaultUserSettings.data
            .summaryAlerts,
        allowedUserTypes:
          nextProps.clientCommunicationState.defaultUserSettings.data
            .allowedUserTypes
      });
      this.setState({
        pageData: pageDataUpdated,
        userTypes: getUserTypeList(
          nextProps.clientCommunicationState.defaultUserSettings.data
            .allowedUserTypes
        )
      });
    }
  }

  addUser() {
    const invalidMsg = validateUserCallData(this.state.pageData);
    if (invalidMsg) {
      toastr.error('Error', invalidMsg);
      return;
    }
    // eslint-disable-next-line no-console
    console.log('Api to add user -- add call');
    this.props.addUser(this.state.pageData);
  }

  editUser() {
    const invalidMsg = validateUserCallData(this.state.pageData);
    if (invalidMsg) {
      toastr.error('Error', invalidMsg);
      return;
    }
    // eslint-disable-next-line no-console
    console.log('Api to save user -- Edit call --');
    this.props.editUser(this.state.pageData);
  }

  showAddUserSections() {
    const pageDataUpdated = Object.assign({}, this.state.pageData, {
      name: null,
      email: null,
      userId: null,
      userType: null,
      mobileNumber: null,
      isSummaryAlert: null,
      isRealTimeAlert: null,
      realTimeAlerts: {},
      summaryAlerts: {}
    });
    this.setState({
      screenName: 'addUser',
      selectedClient: this.state.selectedClient,
      pageData: pageDataUpdated
    });
    this.props.getDefaultUserSettings(this.loggedInUserTypeForClient);
  }

  showNormalUserProfile() {
    this.setState(
      {
        screenName: '',
        userTypes
      },
      () => {
        this.onClientSelect(this.state.selectedClient);
      }
    );
  }

  handleInputChange(val, target) {
    const { name } = target;
    const updated = this.state.pageData;
    updated[name] = val;
    this.setState({
      pageData: updated
    });
  }

  renderInputRow(key, label, disabled) {
    return (
      <div className={`l-row ${styles.inputRow}`}>
        <div className={`${styles.labelDiv}`}>{label}</div>
        <div className={`${styles.inputDivClientCom}`}>
          <InputField
            name={key}
            onChange={(val, target) => this.handleInputChange(val, target)}
            disabled={disabled}
            disabledClass="ccDisableInput"
            value={
              (this.state.pageData &&
                this.state.pageData[key] &&
                this.state.pageData[key].toString()) ||
              ''
            }
          />
        </div>
      </div>
    );
  }

  renderSelectUserTypeRow() {
    return (
      <div className={`l-row ${styles.inputRow}`}>
        <div className={`${styles.labelDiv}`}>User Type</div>
        <div className={`${styles.inputDivClientCom}`}>
          <div>
            <Select
              label="User Type"
              optionsArrOfObj={
                this.state.userTypes && this.state.userTypes.length
                  ? this.state.userTypes
                  : userTypes
              }
              onSelect={(val, obj) => {
                this.onUserTypeSelect(val, obj);
              }}
              disabled={
                !(
                  this.state.pageData &&
                  this.state.pageData.allowedUserTypes &&
                  this.state.pageData.allowedUserTypes.length
                )
              }
              disabledClass="ccDisableInput"
            />
          </div>
        </div>
      </div>
    );
  }

  renderLocationRow() {
    return (
      <div className={`l-row ${styles.inputRow}`}>
        <div className={`${styles.labelDiv}`}>Location</div>
        <div className={`${styles.inputDivClientCom} l-row`}>
          <div className={`${styles.regionTypeWrapper}`}>
            <Select
              label="Region Type"
              optionsArrOfObj={this.state.regionType}
              onSelect={val => {
                this.onRegionTypeSelect(val);
              }}
            />
          </div>

          <div>
            <Select
              label="Cluster Type"
              optionsArrOfObj={this.state.clusterType}
              onSelect={val => {
                this.onClusterTypeSelect(val);
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderAlertSettings() {
    let configuration;
    if (this.state.pageData && this.state.pageData.isRealTimeAlert) {
      configuration = this.state.pageData && this.state.pageData.realTimeAlerts;
      return this.renderRealTimeAlertSettings(configuration);
    } else if (this.state.pageData && this.state.pageData.isSummaryAlert) {
      configuration = this.state.pageData && this.state.pageData.summaryAlerts;
      return this.renderSummaryAlertSettings(configuration);
    }
    return null;
  }

  renderRealTimeAlertSettings(configuration) {
    if (!configuration) {
      return null;
    }
    return <RealTimeAlertsSettings configuration={configuration} />;
  }

  renderSummaryAlertSettings(configuration) {
    if (!configuration) {
      return null;
    }
    return <SummaryAlertSettings configuration={configuration} />;
  }

  renderSearchClientSection() {
    return (
      <div className={`${styles.searchSelectWrapper}`}>
        <div className={`${styles.searchAddContainer} l-row a-center`}>
          <SearchClient
            title="Search Client"
            displayAccessorArray={this.clientDisplayAccessorList}
            displaySeparator="-"
            onChange={val => this.onClientInputChange(val)}
            onSelect={val => this.onClientSelect(val)}
            selectedOpt={this.state.selectedClient || {}}
            placeholder="Search by Client Name, Client Code"
            searchOptions={
              (this.props.clientCommunicationState &&
                this.props.clientCommunicationState
                  .ccPageDataClientWiseFiltered) ||
              []
            }
          />
        </div>
      </div>
    );
  }

  renderSearchUserSection() {
    if (!this.userCreateRoleForClient) {
      return null;
    }
    return (
      <div className={`${styles.searchSelectWrapper}`}>
        {
          // <div className={`${styles.containerTitle}`}>Select User</div>
        }
        <div className={`${styles.searchAddContainer} l-row a-center`}>
          <SearchClient
            title="Search User"
            displayAccessorArray={this.userDisplayAccessorList}
            displaySeparator="-"
            onChange={val => this.onUserInputChange(val)}
            onSelect={val => this.onUserSelect(val)}
            selectedOpt={this.state.selectedUser || {}}
            placeholder="Search by User Name, Phone number, Email address"
            searchOptions={
              (this.props.clientCommunicationState &&
                this.props.clientCommunicationState.userOptionsList) ||
              []
            }
          />
        </div>
      </div>
    );
  }

  renderAddUserSection() {
    if (!this.userCreateRoleForClient) {
      return null;
    }
    return (
      <div className={`${styles.addUserWrapper}`}>
        {
          // <div className={`${styles.containerTitle}`}>Add New User</div>
        }
        <div className={`${styles.searchAddContainer} l-row a-center`}>
          <div
            className={`${styles.addUserBtn} l-row j-center a-center`}
            onClick={() => this.showAddUserSections()}
          >
            Add New User
          </div>
        </div>
      </div>
    );
  }

  renderAddUserFooterBtns() {
    return (
      <div className="add-user-btns l-row">
        <div
          className={`${styles.footerBtn} ${styles.cancelAddUserBtn} l-row j-center a-center`}
          onClick={() => this.showNormalUserProfile()}
        >
          Cancel
        </div>

        <div
          className={`${styles.footerBtn} ${styles.addUserFooterBtn} l-row j-center a-center`}
          onClick={() => this.addUser()}
        >
          Add User
        </div>
      </div>
    );
  }

  renderUserProfileFooterBtns() {
    return (
      <div
        className={`${styles.footerBtn} ${styles.saveBtn} l-row j-center a-center`}
        onClick={() => this.editUser()}
      >
        Save
      </div>
    );
  }

  renderMainPageData() {
    return (
      <div className={`${styles.clientCommunicationWrapper}`}>
        {this.renderSearchClientSection()}
        <div className={`l-row ${styles.searchAddRow}`}>
          {this.state.screenName === 'addUser'
            ? null
            : this.renderSearchUserSection()}
          {this.state.screenName === 'addUser'
            ? null
            : this.renderAddUserSection()}
        </div>

        <div className={`l-col a-center ${styles.userProfileWrapper}`}>
          <div className={`${styles.containerTitle}`}>
            {this.state.screenName === 'addUser' ? 'Add User' : 'User Profile'}
          </div>
          <div className={`${styles.userProfileBody}`}>
            <div className="l-row fields-container">
              <div className="left-column">
                {this.renderInputRow('name', 'Name', false)}
                {this.renderInputRow('email', 'Email ID', false)}
              </div>
              <div className="right-column">
                {this.renderSelectUserTypeRow()}
                {this.renderInputRow('mobileNumber', 'Mobile No', false)}
              </div>
            </div>
            {
              // {this.renderLocationRow()}
            }
            {this.renderAlertSettings()}
          </div>
        </div>

        <div className={`${styles.footerBtnWrapper} l-row j-end`}>
          {this.state.screenName === 'addUser'
            ? this.renderAddUserFooterBtns()
            : this.renderUserProfileFooterBtns()}
        </div>
      </div>
    );
  }

  render() {
    const {
      fetchingInitialPageDetails,
      fetchedInitialPageDetails
    } = this.props.clientCommunicationState;
    if (fetchingInitialPageDetails) {
      return <Loader />;
    } else if (!fetchingInitialPageDetails && fetchedInitialPageDetails) {
      return this.renderMainPageData();
    }
    return null;
  }
}

const mapStateToProps = state => ({
  userProfile: state.userProfile,
  clientCommunicationState: state.clientCommunicationState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getUserClients: bindActionCreators(getUserClients, dispatch),
  getDefaultUserSettings: bindActionCreators(getDefaultUserSettings, dispatch),
  filterClientList: bindActionCreators(filterClientList, dispatch),
  getUserOptionList: bindActionCreators(getUserOptionList, dispatch),
  editUser: bindActionCreators(editUser, dispatch),
  addUser: bindActionCreators(addUser, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientCommunication);
